module.exports = __webpack_public_path__ + "media/images/number_20-29e3cca4cee9aaf99d7d2d59ecddb16b.png";